// src/pages/AuthCallbackPage.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

// This component handles the redirect back from OAuth providers (like Google)

// Accept handleLoginSuccess function as a prop from App.js
const AuthCallbackPage = ({ handleLoginSuccess }) => {
  const [searchParams] = useSearchParams(); // Hook to read URL query parameters
  const navigate = useNavigate(); // Hook for programmatic navigation
  const [message, setMessage] = useState('Processing authentication...'); // Feedback message

  useEffect(() => {
    // Get token and error from URL query parameters
    const token = searchParams.get('token');
    const error = searchParams.get('error');
    // const tokenType = searchParams.get('type'); // Usually 'bearer', might be useful

    console.log("AuthCallbackPage: Token from URL:", token);
    console.log("AuthCallbackPage: Error from URL:", error);

    if (token) {
      // --- Success Case ---
      setMessage('Authentication successful! Redirecting...');
      console.log("AuthCallbackPage: Storing token and calling handleLoginSuccess.");

      // Store the token in localStorage
      localStorage.setItem('authToken', token);

      // Call the function passed from App.js to update global state
      if (typeof handleLoginSuccess === 'function') {
        handleLoginSuccess(); // Sets isAuthenticated=true, closes modal (if open)
      } else {
        console.error("AuthCallbackPage: handleLoginSuccess is not a function!");
        setMessage("Login succeeded but failed to update application state.");
        // Still navigate, but show error?
      }

      // Redirect to the main dashboard after a short delay
      // Using replace: true removes the callback URL from history
      const timer = setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 1000); // 1 second delay

      // Cleanup timer on component unmount
      return () => clearTimeout(timer);

    } else if (error) {
      // --- Error Case ---
      console.error("AuthCallbackPage: Authentication error:", error);
      const userFriendlyError = error.replace(/_/g, ' ') || 'An unknown error occurred during authentication.';
      setMessage(`Authentication failed: ${userFriendlyError}. Redirecting...`);

      // Redirect back to dashboard (or login page?) after showing error
      const timer = setTimeout(() => {
        navigate('/dashboard', { replace: true }); // Or navigate('/') ?
      }, 3000); // 3 second delay

      // Cleanup timer
      return () => clearTimeout(timer);

    } else {
      // --- Unexpected Case (No token, no error) ---
      setMessage('Invalid callback state. Redirecting...');
      console.warn("AuthCallbackPage: Reached callback page without token or error parameter.");
      const timer = setTimeout(() => {
        navigate('/dashboard', { replace: true });
      }, 2000); // 2 second delay

      // Cleanup timer
      return () => clearTimeout(timer);
    }

  // Add dependencies for useEffect
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, navigate, handleLoginSuccess]); // Include handleLoginSuccess if it might change (though unlikely with useCallback)

  // Render simple feedback message while processing
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h2>Authentication Callback</h2>
      <p>{message}</p>
      {/* Optional: Add a loading spinner */}
    </div>
  );
};

export default AuthCallbackPage;
